<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Master Data" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="deleteSuccess"
            :alert="{
              title: 'Berhasil menghapus data',
              type: 'success',
              content: `Jadwal Dokter '${deleteItem.name}' telah berhasil dihapus dari sistem`,
            }"
          />
          <Alert
            v-if="deleteFailed"
            :alert="{
              title: 'Gagal menghapus data',
              type: 'danger',
              content: `Terjadi kesalahan pada sistem. Jadwal Dokter '${deleteItem.name}' gagal dihapus dari sistem`,
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form> -->
          <div class="profile-intro" v-if="nama && unit">
            <img class="profile-img" :src="'/img/user.jpg'" />
            <div class="profile-info">
              <h3>{{ nama }}</h3>
              <h5>{{ kode }}</h5>
              <h4>{{ unit.nama }}</h4>
            </div>
          </div>
          <div class="page-content-title mb-2">
            <div class="left">
              <div>
                <h4 class="title mb-0">Jadwal Praktek</h4>
              </div>
            </div>
            <div class="action">
              <span
                ><span
                  ><a
                    :href="`/#/master/dokter/jadwal/${$route.params.id}`"
                    class="btn btn-primary  btn-with-icon-left ml-2"
                    id="item.id"
                    ><i class="material-symbols-outlined">create</i> Ubah Jadwal
                  </a></span
                ></span
              >
            </div>
          </div>
          <div>
            <datatable
              v-if="loaded && rows.length"
              :columns="columns"
              :per-page="parseInt(perPage)"
              :data="rows"
              :filter="filter"
              class="table table-hover responsive"
            ></datatable>
            <EmptyState
              v-else-if="loaded && !rows.length"
              :data="{ size: 'small' }"
            />
            <Loading v-else />
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
    <button
      v-for="row in rows"
      v-bind:key="row.id + String(Math.random(1023))"
      :id="'delete' + row.id"
      @click="
        () => {
          deleteData(
            row.id,
            row.id_dokter +
              ' ' +
              row.hari +
              ' ' +
              row.jam_mulai +
              ' sampai dengan ' +
              row.jam_selesai
          );
        }
      "
      style="display:none"
    ></button>
    <div class="modal modal-confirm" id="modalDelete" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--  <h5 class="modal-title">Modal title</h5>  -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <h3 class="confirm-title">Delete Confirmation</h3> -->
            <img
              class="img-illustration delete-alert mb-0"
              src="/img/alert-triangle.svg"
              style="width:40%"
            />
            <p class="confirm-content mb-2">
              Apakah Anda yakin untuk menghapus data berikut?
            </p>
            <h4>{{ deleteItem.name }}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-dismiss="modal"
            >
              TIDAK
            </button>
            <button
              id="btnDeleteItem"
              class="btn btn-danger"
              @click="
                () => {
                  confirmDelete(deleteItem.id);
                }
              "
              data-dismiss="modal"
            >
              YA
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Alert from "@/components/Alert.vue";
// import FormGroup from "@/components/FormGroup.vue";
// import { HTTP,HTTP_ENC } from "@/config.js";
let data = {
  title: "Detail Dokter",
  backBtn: "/master/dokter",
  actionBtn: [],
  breadcrumb: [
    { title: "Dokter", link: "/master/dokter" },
    { title: "Detail Dokter", active: true },
  ],
};

let days = {
  Senin: 1,
  Selasa: 2,
  Rabu: 3,
  Kamis: 4,
  Jumat: 5,
  Sabtu: 6,
  Minggu: 7,
};

let emptySchedule = [
  { hari: "Senin", jadwal: [] },
  { hari: "Selasa", jadwal: [] },
  { hari: "Rabu", jadwal: [] },
  { hari: "Kamis", jadwal: [] },
  { hari: "Jumat", jadwal: [] },
  { hari: "Sabtu", jadwal: [] },
  { hari: "Minggu", jadwal: [] },
];

export default {
  name: "DokterDetail",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    Loading,
    Alert,
    EmptyState,
    // FormGroup
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      id_unit: null,
      kode: null,
      nama: "",
      unit: null,
      deleteItem: {
        id: "",
        name: "",
      },
      deleteSuccess: false,
      deleteFailed: false,
      loaded: false,
      columns: [
        {
          label: "Hari",
          field: "hari",
          headerClass: "class-in-header second-class",
          sortable: false,
        },
        {
          label: "Jadwal",
          class: "dropdown",
          sortable: false,
          representedAs: (row) => {
            let schedules = "";
            if (row.jadwal.length) {
              row.jadwal.forEach((item) => {
                schedules += `<span class="badge badge-primary badge-sm mr-2 my-1" style="display:inline-block;">${item.jam_mulai} - ${item.jam_selesai}</span>`;
              });
            } else {
              schedules += `<span class="badge badge-danger badge-sm mr-2 my-1" style="display:inline-block;">Tidak ada jadwal</span>`;
            }

            return `${schedules}`;
          },
          interpolate: true,
        },
        {
          label: "",
          class: "dropdown",
          interpolate: true,
        },
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      rows: [],
      id_dokter: null,
    };
  },
  methods: {
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `dokter/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.id_unit = result.data.id_unit;
          this.kode = result.data.kode;
          this.nama = result.data.nama;
          this.getUnit();
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },

    getUnit: async function() {
      try {
        let result = await this.$store.state.HTTP.get(`unit/${this.id_unit}`);
        if (result.status == "200") {
          this.unit = result.data;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    deleteData(id, name) {
      this.deleteItem = {
        id: id,
        name: name,
      };
    },
    async confirmDelete(id) {
      //console.log(id);
      let result = await this.$store.state.HTTP.delete(
        "dokter/jadwal/harian/" + id
      );
      //console.log(result);
      if (result.status == 200) {
        this.deleteSuccess = true;
        await this.displayList();
        this.$nextTick(() => {
          if (this.$refs.focusMe) {
            this.$refs.focusMe.focus();
          }
        });
      } else {
        this.deleteFailed = true;
      }
      this.resetAlert();
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.deleteSuccess = false;
        self.deleteFailed = false;
      }, 5000);
    },
    async filterTab(filter) {
      //console.log(filter);
      this["id_dokter"] = filter;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(`${e.target.name}:${this[e.target.name]}`);
      await this.displayList();
      // this.$nextTick(()=>{if(this.$refs.focusMe){ this.$refs.focusMe.focus()}});
    },
    displayList: async function() {
      this.loaded = false;
      this.errors = [];
      let params = `?per_page=999999999999&orderBy=asc&id_dokter=${this.id_dokter}`;
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter/jadwal/harian" + params
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          let schedules = result.data.data;
          let self = this;
          this.rows = emptySchedule;
          schedules.forEach((item) => {
            if (self.rows.length) {
              let index = -1;
              let found = self.rows.find((row, i) => {
                if (item.hari == row.hari) {
                  index = i;
                }
                return item.hari == row.hari;
              });
              if (found && index > -1) {
                // found.jadwal=found.jadwal.concat({jam_mulai:item.jam_mulai,jam_selesai:item.jam_selesai});
                self.rows[index].jadwal = self.rows[index].jadwal.concat({
                  jam_mulai: item.jam_mulai,
                  jam_selesai: item.jam_selesai,
                });
              } else {
                self.rows = self.rows.concat({
                  no: days[item.hari],
                  hari: item.hari,
                  jadwal: [
                    {
                      jam_mulai: item.jam_mulai,
                      jam_selesai: item.jam_selesai,
                    },
                  ],
                });
              }
            } else {
              self.rows = self.rows.concat({
                no: days[item.hari],
                hari: item.hari,
                jadwal: [
                  { jam_mulai: item.jam_mulai, jam_selesai: item.jam_selesai },
                ],
              });
            }
          });

          this.loaded = true;
          // this.rows=this.rows.sort((a,b) => (a.no > b.no) ? 1 : ((b.no > a.no) ? -1 : 0));
          //console.log(this.rows);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.id_dokter = this.$route.params.id;
    this.displayData();
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
  },
};
</script>
